jQuery(document).ready(function($){
    jQuery('.faq-section').find('.accordion-toggle').click(function(){
        var isActive = jQuery(this).hasClass("active");
        jQuery('.accordion-toggle').removeClass('active')
            if (!isActive) {
        jQuery(this).toggleClass('active');
        }
        jQuery(this).next().slideToggle('fast'); //Hide the other panels
        jQuery(".accordion-toggle + .content").not(jQuery(this).next()).slideUp('fast');
    });
    jQuery(window).scroll(function() {
      var sticky = jQuery('.main-section-header'),
      scroll = jQuery(window).scrollTop();
      if (scroll >= 360) sticky.addClass('fixed');
      else sticky.removeClass('fixed');
    });
});


$(document).ready(function(){
  $(".custom_banner_slider").owlCarousel({
  loop: true,
  margin: 0,
  nav: false,
  dots: false,
  autoplay: true,
  autoplayTimeout: 5000,
  autoplaySpeed: 1000,
  smartSpeed: 1000, 
  autoplayHoverPause: true,
  responsive: {
  0: { items: 1 }
  }
  });
  });


jQuery(document).ready(function () {
    jQuery('.boost-pfs-filter-product-item').each(function () {
        var sku = jQuery(this).find('.product-form__selected-variant').data('sku'); // SKU ko extract karna
        if (sku) {
            jQuery(this).find('.boost-pfs-filter-product-item-title')
                .after('<p class="product-sku">SKU: ' + sku + '</p>'); // SKU insert karna
        }
    });
});
